export default {
      id: "gas_station-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#gas_station",
      toString: function () {
        return this.url;
      }
    }